import { Text, Box, SxStyleProp } from 'theme-ui';
import { useTranslator } from '@picsart/rc/services/localization';
import { CombinedData, currencySymbol } from '../OneTimePayAccordion';
import { ThumbnailImage } from './ThumbnailImage';
import Icon from 'shared/Icon';
import { PREMIUM_ITEMS } from '../../../constants';

const ContentItemStyle: SxStyleProp = {
  position: 'relative',
  height: 38,
  boxSizing: 'content-box',
  border: '1px solid',
  borderRadius: 8,
  borderColor: 'grey3',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingRight: 4
};

export const ContentItem = ({ type, price, src, count }: CombinedData) => {
  const translate = useTranslator();
  const premiumItem = PREMIUM_ITEMS[type];

  return (
    <Box sx={ContentItemStyle}>
      {src ? (
        <ThumbnailImage type={type} src={src} />
      ) : (
        <Icon
          sx={{
            position: 'absolute',
            marginLeft: 16,
            width: 14,
            height: 14
          }}
          name="gold-circle-gen"
        />
      )}
      <Text variant="bulletSmall" sx={{ paddingLeft: 52, fontSize: 12 }}>
        {translate(premiumItem.name || 'not found')}
        {premiumItem && premiumItem.showCount && ` (${count})`}
      </Text>
      <div style={{ paddingRight: 12, display: 'flex', alignItems: 'center', fontSize: 14 }}>
        <Text variant="bulletSmall">{currencySymbol}</Text>
        <Text variant="bulletSmall">{price * count}</Text>
      </div>
    </Box>
  );
};
